import React, {useState} from "react";
import popupStore from "../../../store/popupStore";
import {VARIANT} from "../../../constants";
import Button from "../../Common/Button";
import {fetchCreateOrderNote, fetchOrderNotes, fetchOrders} from "../../../services/orderServices";
import {useSearchParams} from "react-router-dom";

const FormNote = ({orderId, isDetail = false}) => {
  const {setPopup} = popupStore();
  const [searchParams] = useSearchParams();
  const [content, setContent] = useState('');
  const [loading, setLoading] = useState(false);

  const handleSubmit = async () => {
    if (!content.trim()) return;
    setLoading(true);
    try {
      const res = await fetchCreateOrderNote(orderId, {content});
      if (res?.message === 'success' || res?.status === 200 || res?.data?.message === 'success') {
        setPopup({});
        // Refresh the appropriate list to update notes
        if (isDetail) {
          fetchOrderNotes(orderId, {page: 1, size: 15});
        } else {
          // Get current filters from URL to refresh with same state as OrdersPage
          const status = searchParams.get('status') || '';
          const search = searchParams.get('query') || '';
          const page = parseInt(searchParams.get('page') || '1');
          const sort_field = searchParams.get('sort_field') || 'created_at';
          const sort_direction = searchParams.get('sort_direction') || 'DESC';

          await fetchOrders({
            page,
            size: 10,
            search,
            status,
            sort_field,
            sort_direction
          });
        }
      }
    } catch (error) {
      console.error("Failed to save note", error);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="flex flex-col gap-4 rounded-lg w-80 md:w-[800px]">
      <div className="text-lg font-bold">Ghi chú</div>
      <textarea
        value={content}
        onChange={(e) => setContent(e.target.value)}
        placeholder="Nhập ghi chú cho đơn hàng"
        className="w-full h-24 p-3 border border-gray-200 rounded-lg resize-none focus:outline-none focus:ring-2 focus:ring-green-600 focus:border-transparent text-sm"
      />
      <div className="flex gap-3 justify-center">
        <Button
          onClick={handleSubmit}
          disabled={!content.trim() || loading}
          className="px-8 text-sm"
          variant={(!content.trim() || loading) ? VARIANT?.SECONDARY : VARIANT.PRIMARY}
        >
          {loading ? 'Đang lưu...' : 'Lưu'}
        </Button>
        <Button
          onClick={() => setPopup({})}
          className="px-8 border text-sm border-gray-200 bg-white !text-black hover:bg-gray-50"
        >
          Huỷ
        </Button>
      </div>
    </div>
  );
};

export default FormNote;
